<template>
  <div>
    <el-collapse v-model="activeNames" @change="handleChange"
                 class="accordion">
      <el-collapse-item v-for="sector in shops" v-bind:key="sector.name">
        <template slot="title">
          <h2 class="accordion--title">{{sector.name}}</h2>
        </template>
        <hr class="separator">
        <div v-for="shop in sector.mags"
             v-bind:key="shop.id"
             class="accordion--item">
          <h4 class="accordion--item--name">{{shop.name}}</h4>
          <el-button type="primary"
                     plain
                     size="mini"
                     :loading="loading"
                     class="accordion--item--button"
                     @click="shopConnexion(shop.id, shop.email)">Connexion
          </el-button>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>

  export default {
    components: {},
    data() {
      return {
        loading: false,
        activeNames: ['1'],
      };
    },
    props: {
      shops: {},
    },
    methods: {
      handleChange(val) {
        console.log(val);
      },
      shopConnexion(shopId, shopEmail) {
        const shopInfo = {
          id: shopId,
          email: shopEmail,
        };
        this.$emit('shopConnexion', shopInfo);
      },
    },
  };
</script>

<style lang="stylus">
  .accordion {
    margin 0 auto
    width: 700px;
  }

  .accordion--item {
    display flex
    flex-direction row
    margin-left 50px
    margin-right 50px
    margin-bottom 10px
    justify-content space-between
  }

  .accordion--item--button {
  }

  .accordion--title {
    color #5daf34
  }

  .accordion--item--name {
    color #2a8eec
  }
  .separator {
    width 80%
    margin-bottom 20px
  }
</style>
